export default function () {
    $('body').on('mouseenter', '.herald-fa-item', function() {
        var excerpt_height = $(this).find('.entry-content').height();

        $(this).find('.entry-header').css({
            "-webkit-transform": "translate(0,-" + excerpt_height + "px)",
            "-ms-transform": "translate(0,-" + excerpt_height + "px)",
            "transform": "translate(0,-" + excerpt_height + "px)"
        });
    });


    $('body').on('mouseleave', '.herald-fa-item', function() {
        $(this).find('.entry-header').css({
            "-webkit-transform": "translate(0,0)",
            "-ms-transform": "translate(0,0)",
            "transform": "translate(0,0)"
        });
    });
}
